<template>
    <header class="header">
      <div class="logo">
        <a class="logo_link" href="https://shop.t-l.ch/" target="_blank">
          <svg
          version="1.1"
          id="Calque_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 200 200"
          style="enable-background:new 0 0 200 200;"
          xml:space="preserve"
          >
            <g>
              <g>
                <path
                  fill="#fffff"
                  class="st0"
                  d="M105.98,142.35c-10.66,0-13.46-5.59-13.46-16.62V92.15h23.56V70.11H92.52V40.03l-33.1,9.63v20.46H39.59v22.04
                  h19.27v37.08c0,21.69,7.3,34.11,37.4,34.11c8.42,0,14.78-1.05,21.13-1.75l-1.11-20.47C112.91,141.65,109.36,142.35,105.98,142.35"
                />
                <rect
                  x="127.69"
                  y="40.5"
                  class="st0"
                  width="33.86"
                  height="120.74"
                />
              </g>
            </g>
          </svg>
        </a>
        <!--<span class="logo_baseline">Les transports lausannois vous accompagnent dans votre choix d’abonnement.</span>-->
      </div>
    </header>

    <main class="main">
      <div class="wrapper">
        <template v-if="!isStarted">
          <Intro class="intro"></Intro>
        </template>
        <template v-else>
          <Breadcrumb class="breadcrumb"></Breadcrumb>
          <template v-if="!isResults">
            <Questions class="questions"></Questions>
          </template>
          <template v-else>
            <Results class="results"></Results>
          </template>
        </template>
      </div>
    </main>
</template>

<script>
  import { mapState } from 'vuex'
  import Intro from './components/Intro'
  import Breadcrumb from './components/Breadcrumb'
  import Questions from './components/Questions'
  import Results from './components/Results'

  export default {
    name: 'Home',
    title: 'TrouverMonAboTL',
    components: {
      Intro,
      Breadcrumb,
      Questions,
      Results
    },
    data: () => ({
      isLoaded: false,
    }),
    async created() {
      try {
        await this.$store.dispatch('fetchData')
      } catch(err) {
        console.error(err)
      }
    },
    mounted() {
    },
    computed: {
      ...mapState([
          'isLoading',
          'isStarted',
          'isResults'
      ])
    },
    methods: {}
  }
</script>

<style lang="scss">
@use '~@wide/styles-utils' as *;
@import '@/assets/scss/variables';
@import '@/assets/scss/main';

#app {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  height: -webkit-fill-available;
}

.header {
  flex: 0 0;
  padding: 2rem;

  .logo {
    display: flex;
    align-items: center;
    height: 5rem;
    color: $white;

    &_link {
      flex: 0 0 5rem;
    }

    &_baseline {
      max-width: 27rem;
      font-size: 1.2rem;
      margin-left: 1rem;
    }
  }
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 9rem);
  margin: 0 auto;

  @include bp-up(md) {
    height: 100%;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    padding: 3rem;

    @include bp-up(md) {
      max-height: 768px;
      max-width: 1024px;
    }

    .loading {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 2rem;
    }

    .breadcrumb {
      margin-bottom: 3rem;
    }
  }
}


</style>
